import { useKV } from "@/hooks/use-kv-adapter";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ClockCounterClockwise } from "@phosphor-icons/react";

interface AuditLogEntry {
  id: string;
  action: string;
  module: string;
  performedBy: string;
  timestamp: string;
  details: string;
  ipAddress?: string;
}

export function AuditLogs() {
  // Use existing logs or create new KV
  const [logs] = useKV<AuditLogEntry[]>("core-hr-audit-logs", [
    {
      id: "1",
      action: "Profile Update",
      module: "Employee Directory",
      performedBy: "Admin User",
      timestamp: new Date().toISOString(),
      details: "Updated John Doe's designation to Senior Engineer",
      ipAddress: "192.168.1.1"
    },
    {
      id: "2",
      action: "Document Upload",
      module: "Document Vault",
      performedBy: "HR Manager",
      timestamp: new Date(Date.now() - 3600000).toISOString(),
      details: "Uploaded Employment Contract for Jane Smith",
      ipAddress: "192.168.1.5"
    }
  ]);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ClockCounterClockwise className="w-5 h-5" /> Audit Logs
        </CardTitle>
        <CardDescription>Track all changes and access within the HR system.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Timestamp</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Module</TableHead>
              <TableHead>Performed By</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-8 text-slate-500">
                  No logs found.
                </TableCell>
              </TableRow>
            ) : (
              logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell className="whitespace-nowrap text-xs text-slate-500">
                    {new Date(log.timestamp).toLocaleString()}
                  </TableCell>
                  <TableCell className="font-medium">{log.action}</TableCell>
                  <TableCell>
                    <Badge variant="outline">{log.module}</Badge>
                  </TableCell>
                  <TableCell>{log.performedBy}</TableCell>
                  <TableCell className="max-w-md truncate" title={log.details}>
                    {log.details}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
